/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import AccountWishlistTile from './account-wishlist-tile';
import AccountWishlistTileView from './account-wishlist-tile.view';

export * from './account-wishlist-tile';
export * from './account-wishlist-tile.data';
export {
    IAccountWishlistTileConfig,
    IAccountWishlistTileProps,
    IAccountWishlistTileResources
} from './account-wishlist-tile.props.autogenerated';
export * from './account-wishlist-tile.view';

export { AccountWishlistTile, AccountWishlistTileView };
